import { AnalyticsBrowser } from '@segment/analytics-next'
import { getConfig } from '/@/conf'
import { getCookie } from '/@/utils/cookie'

declare global {
  interface Window {
    analytics?: AnalyticsBrowser
  }
}

function loadSegment() {
  const config = getConfig()
  if (!config.apiKeys.segment) return undefined

  const analytics = AnalyticsBrowser.load(
    {
      writeKey: config.apiKeys.segment,
      cdnURL: config.urls.segmentCdnUrl,
    },
    {
      integrations: {
        'Segment.io': { apiHost: config.urls.segmentApiHost },
      },
    },
  )

  const anonymousId = getCookie(document.cookie, 'spk_anonymous_id')
  if (anonymousId) analytics.setAnonymousId(anonymousId)

  return analytics
}

export const segment = loadSegment()

if (segment) window.analytics = segment
